import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'mx-4 flex items-center pb-2 pt-6 between lg:(mx-6 pb-4)',
    carouselExternalControls: 'hidden',
    carouselExternalControlsColor: '@hactive:bg-brand-2',
    carouselContainer: '-mr-2',
    carouselControls: '',
    carouselCard: 'pr-2',
    carouselCardContent: 'pl-2',
  },
  carouselAlign: undefined,
  carouselArrows: 'on',
  carouselArrowsSize: 'md',
  carouselLoop: false,
  spacing: {
    none: 0,
    small: 0.25,
    medium: 0.5,
    large: 1,
    xlarge: 2
  },
} satisfies CMSConfig['articleCarousel']
